import { atom } from 'jotai'
import { processedPhasesAtom } from './processedPhases.atom'
import { toBillingFrequencyLabel, toMoney } from '@sequencehq/utils'
import { ProcessedPhase } from './scheduleData.atom'

type MinimumHistory = {
  id: string
  summary: {
    amount: string
    frequency: string
  }
  productIds: Array<string>
  startDate: Date
  endDate: Date
  openEnded: boolean
}

export const parseMinimumsHistory = (sortedPhases: Array<ProcessedPhase>) => {
  const scheduleCurrency = sortedPhases[0]?.prices[0]?.currency

  return sortedPhases.reduce(
    (acc, phase) => {
      if (!phase.minimums.length) {
        return acc
      }

      const phaseMinimum = phase.minimums[0]
      const minimumPrices = phaseMinimum.restrictToPrices.length
        ? phase.prices.filter(p => phaseMinimum.restrictToPrices.includes(p.id))
        : phase.prices

      const minimumFrequency = minimumPrices[0].billingFrequency
      const productIdsForMinimum = minimumPrices.map(price => price.productId)

      return [
        ...acc,
        {
          id: `${phase.id}.minimum`,
          summary: {
            amount: toMoney({
              value: `${phaseMinimum.amount}`,
              currency: scheduleCurrency
            }),
            frequency: toBillingFrequencyLabel(minimumFrequency)
          },
          productIds: productIdsForMinimum,
          startDate: phase.startDate,
          endDate: phase.endDate,
          openEnded: phase.openEnded
        }
      ]
    },
    [] as Array<MinimumHistory>
  )
}

export const minimumsHistoryAtom = atom<Array<MinimumHistory>>(get => {
  const sortedPhases = get(processedPhasesAtom)

  return parseMinimumsHistory(sortedPhases)
})
